import module from './module.js'

import './components/component.js'
import './components/bancos/component.js'
import './components/bancos/detallado/component.js'
import './components/bancos/layout/component.js'
import './components/bancos/layout/banco/component.js'
import './components/bancos/layout/invalidos/component.js'
import './components/bancos/layout/lista/component.js'
import './components/bancos/pagos/component.js'
import './components/bancos/pagos/cargamultiple/component.js'
import './components/bancos/pagos/cargamultiple/decoder/component.js'
import './components/bancos/pagos/cargamultiple/editar/component.js'
import './components/bancos/pagos/empleado/item/component.js'
import './components/bancos/pagos/empleado/pago/component.js'
import './components/bancos/pagos/empleado/pagos/component.js'
import './components/bancos/recibos/component.js'
import './components/bancos/recibos/confirmar/component.js'
import './components/bancos/recibos/lista/component.js'
import './components/bancos/recibos/lista/item/component.js'
import './components/bancos/recibosindividuales/component.js'
import './components/bancos/recibosindividuales/confirmar/component.js'
import './components/bancos/resumen/component.js'
import './components/calculo/component.js'
import './components/calculo/calcular/component.js'
import './components/calculo/calcular/motor/component.js'
import './components/calculo/calcular/resultados/component.js'
import './components/calculo/calcular/resultados/noremunerado/component.js'
import './components/calculo/calcular/resultados/remunerado/component.js'
import './components/colaboradores/component.js'
import './components/colaboradores/agregar/component.js'
import './components/colaboradores/agregar/excel/component.js'
import './components/colaboradores/agregar/individual/component.js'
import './components/colaboradores/agregar/individual/colaborador/component.js'
import './components/colaboradores/agregar/individual/lista/component.js'
import './components/colaboradores/agregar/vincular/component.js'
import './components/colaboradores/colaborador/component.js'
import './components/colaboradores/colaborador/concepto/component.js'
import './components/colaboradores/colaborador/concepto/dias/component.js'
import './components/colaboradores/colaborador/concepto/generico/component.js'
import './components/colaboradores/colaborador/concepto/horas/component.js'
import './components/colaboradores/colaborador/conceptos/component.js'
import './components/colaboradores/colaborador/configuracion/component.js'
import './components/colaboradores/descuentos/component.js'
import './components/colaboradores/descuentos/aplicar/component.js'
import './components/colaboradores/descuentos/aplicar/confirmar/component.js'
import './components/colaboradores/descuentos/eliminar/component.js'
import './components/colaboradores/descuentos/eliminar/confirmar/component.js'
import './components/colaboradores/detallado/component.js'
import './components/colaboradores/lista/component.js'
import './components/colaboradores/lista/noremunerados/component.js'
import './components/colaboradores/lista/noremunerados/item/component.js'
import './components/colaboradores/lista/remunerados/component.js'
import './components/colaboradores/lista/remunerados/editar/component.js'
import './components/colaboradores/lista/remunerados/eliminar/component.js'
import './components/colaboradores/lista/remunerados/item/component.js'
import './components/colaboradores/resumen/component.js'
import './components/colaboradores/resumen/colapsado/component.js'
import './components/colaboradores/resumen/extendido/component.js'
import './components/comisionistas/component.js'
import './components/comisionistas/grafica/component.js'
import './components/configuracion/component.js'
import './components/configuracion/descuentos/component.js'
import './components/configuracion/pagos/component.js'
import './components/configuracion/pagos/colaborador/component.js'
import './components/configuracion/pagos/colaborador/observaciones/component.js'
import './components/configuracion/pagos/colaborador/pago/component.js'
import './components/configuracion/pagos/tipocambio/component.js'
import './components/deducciones/component.js'
import './components/deducciones/detallado/component.js'
import './components/dispersion/component.js'
import './components/dispersion/pagos/component.js'
import './components/dispersion/pagos/cancelar/component.js'
import './components/dispersion/pagos/cancelar/confirmar/component.js'
import './components/dispersion/pagos/dividir/component.js'
import './components/dispersion/pagos/dividir/confirmar/component.js'
import './components/dispersion/pagos/exportar/component.js'
import './components/dispersion/pagos/exportar/confirmar/component.js'
import './components/dispersion/pagos/imprimir/component.js'
import './components/dispersion/pagos/imprimir/confirmar/component.js'
import './components/dispersion/pagos/otros/component.js'
import './components/dispersion/pagos/otros/lista/component.js'
import './components/dispersion/pagos/otros/lista/item/component.js'
import './components/dispersion/pagos/otros/lista/item/numerocheque/component.js'
import './components/dispersion/pagos/pagar/component.js'
import './components/dispersion/pagos/pagar/confirmar/component.js'
import './components/dispersion/pagos/progreso/component.js'
import './components/dispersion/pagos/transferencias/component.js'
import './components/dispersion/pagos/transferencias/lista/component.js'
import './components/dispersion/pagos/transferencias/lista/item/component.js'
import './components/dispersion/status/component.js'
import './components/dispersion/vinculacion/component.js'
import './components/dispersion/vinculacion/item/component.js'
import './components/documentos/component.js'
import './components/documentos/acuserecibo/componet.js'
import './components/documentos/acuserecibo/agregar/componet.js'
import './components/documentos/acuserecibo/item/componet.js'
import './components/documentos/cfdi/component.js'
import './components/documentos/cfdi/configuracion/component.js'
import './components/documentos/cfdi/configuracion/item/component.js'
import './components/documentos/cfdi/configuracion/lista/component.js'
import './components/documentos/cfdi/generador/component.js'
import './components/documentos/cfdi/generador/item/component.js'
import './components/documentos/cfdi/item/component.js'
import './components/documentos/comprobantedeposito/componet.js'
import './components/documentos/comprobantedeposito/agregar/componet.js'
import './components/documentos/comprobantedeposito/item/componet.js'
import './components/documentos/cotizacion/componet.js'
import './components/documentos/cotizacion/generar/componet.js'
import './components/documentos/layoutsbancarios/component.js'
import './components/documentos/layoutsbancarios/completados/component.js'
import './components/documentos/layoutsbancarios/completados/layout/component.js'
import './components/documentos/layoutsbancarios/completados/layout/lista/component.js'
import './components/documentos/layoutsbancarios/pendientes/component.js'
import './components/documentos/layoutsbancarios/pendientes/layout/component.js'
import './components/documentos/layoutsbancarios/pendientes/layout/lista/component.js'
import './components/documentos/layoutsh2h/component.js'
import './components/documentos/layoutsh2h/disponibles/component.js'
import './components/documentos/layoutsh2h/disponibles/layout/component.js'
import './components/documentos/layoutsh2h/disponibles/layout/lista/component.js'
import './components/documentos/layoutsh2h/disponibles/layout/confirmar/component.js'
import './components/documentos/layoutsh2h/completados/component.js'
import './components/documentos/layoutsh2h/completados/layout/component.js'
import './components/documentos/layoutsh2h/completados/layout/lista/component.js'
import './components/documentos/tabulado/component.js'
import './components/documentos/tabulado/generar/component.js'
import './components/eliminar/component.js'
import './components/eliminar/confirmar/component.js'
import './components/financiamiento/component.js'
import './components/financiamiento/cancelar/component.js'
import './components/financiamiento/cancelar/confirmar/component.js'
import './components/financiamiento/financiar/component.js'
import './components/financiamiento/financiar/confirmar/component.js'
import './components/informacion/component.js'
import './components/informacion/af/component.js'
import './components/informacion/af/editar/component.js'
import './components/informacion/cerrar/component.js'
import './components/informacion/configuracion/component.js'
import './components/informacion/configuracion/editar/component.js'
import './components/informacion/configuracion/editar/comision/component.js'
import './components/informacion/configuracion/editar/conceptos/component.js'
import './components/informacion/configuracion/editar/impuestos/component.js'
import './components/informacion/configuracion/editar/periodo/component.js'
import './components/informacion/configuracion/editar/principal/component.js'
import './components/informacion/configuracion/editar/suministro/component.js'
import './components/informacion/configuracion/editar/vinculacion/component.js'
import './components/informacion/cotizacion/component.js'
import './components/informacion/fechapago/component.js'
import './components/informacion/fechapago/editar/component.js'
import './components/informacion/op/component.js'
import './components/informacion/op/editar/component.js'
import './components/informacion/principal/component.js'
import './components/informacion/principal/editar/component.js'
import './components/informacion/sa/component.js'
import './components/informacion/sa/editar/component.js'
import './components/informacion/sa/total/completo/component.js'
import './components/informacion/sa/total/noremunerados/component.js'
import './components/informacion/sa/total/remunerados/component.js'
import './components/operadora/component.js'
import './components/operadora/depositos/component.js'
import './components/operadora/depositos/deposito/component.js'
import './components/operadora/depositos/nuevo/component.js'
import './components/operadora/ingreso/component.js'
import './components/recibos/component.js'
import './components/recibos/generador/component.js'
import './components/recibos/lista/component.js'
import './components/sa/component.js'
import './components/sa/depositos/component.js'
import './components/sa/depositos/deposito/component.js'
import './components/sa/depositos/nuevo/component.js'
import './components/sa/ingreso/component.js'
import './components/saldos/component.js'
import './components/saldos/detalle/component.js'
import './components/saldos/detalle/movimientos/movimiento/component.js'
import './components/saldos/detalle/movimientos/nuevo/component.js'
import './components/saldos/detalle/nominas/nomina/component.js'
import './components/saldos/detalle/saldos/saldo/component.js'
import './components/status/component.js'
import './components/status/acumulado/component.js'
import './components/status/acumulado/actualizar/component.js'
import './components/status/maquilado/component.js'
import './components/status/maquilado/actualizar/component.js'
import './components/timbres/component.js'
import './components/timbres/consultar/component.js'
import './components/timbres/consultar/confirmar/component.js'
import './components/timbres/cancelar/component.js'
import './components/timbres/cancelar/confirmar/component.js'
import './components/timbres/cliente/component.js'
import './components/timbres/generarxml/component.js'
import './components/timbres/generarxml/confirmar/component.js'
import './components/timbres/lista/component.js'
import './components/timbres/lista/item/component.js'
import './components/timbres/lista/item/estatus/component.js'
import './components/timbres/pagadora/component.js'
import './components/timbres/timbrar/component.js'
import './components/timbres/timbrar/confirmar/component.js'
import './components/timbres/timbre/editar/component.js'

import './routes/nomina.js'
import './routes/nomina/bancos.js'
import './routes/nomina/bancosresumen.js'
import './routes/nomina/calculo.js'
import './routes/nomina/colaboradores.js'
import './routes/nomina/comisionistas.js'
import './routes/nomina/configuracion.js'
import './routes/nomina/deducciones.js'
import './routes/nomina/dispersion.js'
import './routes/nomina/documentos.js'
import './routes/nomina/informacion.js'
import './routes/nomina/layoutbancario.js'
import './routes/nomina/layouth2h.js'
import './routes/nomina/maquilado.js'
import './routes/nomina/pagos.js'
import './routes/nomina/recibos.js'
import './routes/nomina/recibosbancarios.js'
import './routes/nomina/saldos.js'
import './routes/nomina/timbres.js'
import './routes/nomina/bancos/pagos.js'
import './routes/nomina/colaboradores/descuentos.js'
import './routes/nomina/colaboradores/detallado.js'
import './routes/nomina/configuracion/descuentos.js'
import './routes/nomina/configuracion/pagos.js'
import './routes/nomina/dispersion/pagos.js'
import './routes/nomina/dispersion/pagos/vinculacion.js'

import './services/Nomina.js'
import './services/Nomina/Bancos.js'
import './services/Catalogo/MetodoPago.js'
import './services/Catalogo/Moneda.js'
import './services/Catalogo/TipoPago.js'
import './services/Nomina/Colaboradores.js'
import './services/Nomina/Comisionistas.js'
import './services/Nomina/Conceptos.js'
import './services/Nomina/Configuracion.js'
import './services/Nomina/Dispersion.js'
import './services/Nomina/Documentos.js'
import './services/Nomina/Empleados.js'
import './services/Nomina/Empresasasociadas.js'
import './services/Nomina/Exportar.js'
import './services/Nomina/Financiamiento.js'
import './services/Nomina/Informacion.js'
import './services/Nomina/Layoutbancario.js'
import './services/Nomina/Movimientos.js'
import './services/Nomina/Operadora.js'
import './services/Nomina/Pagos.js'
import './services/Nomina/Permisos.js'
import './services/Nomina/Recibos.js'
import './services/Nomina/Sa.js'
import './services/Nomina/Saldos.js'
import './services/Nomina/Status.js'
import './services/Nomina/Suministro.js'
import './services/Nomina/Timbres.js'
import './services/Nomina/Bancos/Detallado.js'
import './services/Nomina/Bancos/Pagos.js'
import './services/Nomina/Bancos/Recibos.js'
import './services/Nomina/Bancos/Resumen.js'
import './services/Nomina/Bancos/Recibos/RecibosPagos.js'
import './services/Nomina/Bancos/Recibos/Individual.js'
import './services/Nomina/Calculo/Conceptos.js'
import './services/Nomina/Calculo/Colaboradores.js'
import './services/Nomina/Calculo/Configuracion.js'
import './services/Nomina/Calculo/Script.js'
import './services/Nomina/Colaboradores/Colaborador.js'
import './services/Nomina/Colaboradores/Cuentas.js'
import './services/Nomina/Colaboradores/Descuentos.js'
import './services/Nomina/Comisionistas/Comisionista.js'
import './services/Nomina/Comisionistas/Operadora.js'
import './services/Nomina/Configuracion/Pagos.js'
import './services/Nomina/Configuracion/Colaboradores/Descuentos/Conceptos.js'
import './services/Nomina/Deducciones/Detallado.js'
import './services/Nomina/Dispersion/Pagos.js'
import './services/Nomina/Dispersion/Pagos/Dividir.js'
import './services/Nomina/Dispersion/Pagos/Otros.js'
import './services/Nomina/Dispersion/Pagos/Pagados.js'
import './services/Nomina/Dispersion/Pagos/Transferencias.js'
import './services/Nomina/Dispersion/Pagos/Otros/Folio.js'
import './services/Nomina/Dispersion/Pagos/Pagados/Pago.js'
import './services/Nomina/Dispersion/Vinculacion.js'
import './services/Nomina/Documentos/Acuserecibo.js'
import './services/Nomina/Documentos/Cheques.js'
import './services/Nomina/Documentos/Comprobantedeposito.js'
import './services/Nomina/Documentos/Cotizacion.js'
import './services/Nomina/Documentos/Layoutsbancarios.js'
import './services/Nomina/Documentos/Layoutsh2h.js'
import './services/Nomina/Documentos/Tabulado.js'
import './services/Nomina/Documentos/Cotizacion/Configuracion.js'
import './services/Nomina/Documentos/Layoutsbancarios/Layout.js'
import './services/Nomina/Documentos/Layoutsbancarios/Pendientes.js'
import './services/Nomina/Documentos/Layoutsbancarios/Pendientes/Layout.js'
import './services/Nomina/Documentos/Layoutsh2h/Layout.js'
import './services/Nomina/Documentos/Layoutsh2h/Disponibles.js'
import './services/Nomina/Documentos/Layoutsh2h/Disponibles/Layout.js'
import './services/Nomina/Exportar/Bancos.js'
import './services/Nomina/Exportar/Movimientos.js'
import './services/Nomina/Exportar/Resumen.js'
import './services/Nomina/Exportar/Servicios.js'
import './services/Nomina/Exportar/Bancos/Resumen.js'
import './services/Nomina/Informacion/Af.js'
import './services/Nomina/Informacion/Fecha.js'
import './services/Nomina/Informacion/Fechapago.js'
import './services/Nomina/Informacion/Op.js'
import './services/Nomina/Informacion/Principal.js'
import './services/Nomina/Informacion/Sa.js'
import './services/Nomina/Informacion/Tipocambio.js'
import './services/Nomina/Movimientos/Detallado.js'
import './services/Nomina/Movimientos/Empleados.js'
import './services/Nomina/Movimientos/Movimiento.js'
import './services/Nomina/Movimientos/Empleados/Empleado.js'
import './services/Nomina/Operadora/Cuentasbancarias.js'
import './services/Nomina/Operadora/Depositos.js'
import './services/Nomina/Operadora/Ingreso.js'
import './services/Nomina/Operadora/Depositos/Deposito.js'
import './services/Nomina/Pagos/Otros/Folio.js'
import './services/Nomina/Sa/Configuracion.js'
import './services/Nomina/Sa/Cuentasbancarias.js'
import './services/Nomina/Sa/Depositos.js'
import './services/Nomina/Sa/Ingreso.js'
import './services/Nomina/Sa/Depositos/Deposito.js'
import './services/Nomina/Saldos/Saldo.js'
import './services/Nomina/Status/Acumulado.js'
import './services/Nomina/Status/Aprobado.js'
import './services/Nomina/Status/Calculado.js'
import './services/Nomina/Status/Cotizado.js'
import './services/Nomina/Status/Maquilado.js'
import './services/Nomina/Status/Pagado.js'
import './services/Nomina/Timbres/Timbre.js'
import './services/Nomina/Timbres/Timbre/XML.js'
import './services/Nomina/Timbres/Timbre/Estatus/Cancelado.js'
import './services/Nomina/Timbres/Timbre/Estatus/Timbrado.js'
// Factories
import './factories/Nomina/Calculo.js'

export default module.name



// WEBPACK FOOTER //
// ./src/nominas/nomina/index.js